export default __webpack_public_path__ + "static/media/PanazV.88e75bf4.jpg";